import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";
interface UseGetCostTrialBalanceReportProps {
  communityId: string;
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCostTrialBalanceReport = async (communityId: string, filter: any) =>
  await axiosAuth.get(`${DISTRIBUTION_REPORT_API}/${communityId}/reports/trial-balance/cost-analytics?${new URLSearchParams(filter).toString()}`);

const useGetCostTrialBalanceReport = ({
  queryParams,
  communityId,
  filter
}: UseGetCostTrialBalanceReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["cost-trial-balance-report", communityId],
    queryFn: () => getCostTrialBalanceReport(communityId, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetCostTrialBalanceReport;
